import { observer } from 'mobx-react';
import { Ready } from '../../Types';
import TooltippedTitle from '../TooltippedTitle';
import LicenseAlert from './LicenseAlert';
import { T } from '../../../../../Translations';

interface Props {
  state: Ready;
}

function Overview({ state }: Props) {
  return (
    <>
      <TooltippedTitle title="License Insights">
        <T kind="Maximize your opportunities and plan ahead..." />
      </TooltippedTitle>
      {state.resource.payload.licenseInsights.map((li, index) => (
        <LicenseAlert key={li.key} licenseInsight={li} insightIndex={index} />
      ))}
    </>
  );
}

export default observer(Overview);
